/**
 * Subscriber identity used only by the dashboard Web Chat tester.
 * Customer-app smoke tests still use the raw dashboard user id (see the Cursor
 * install prompt), so Connected must never key off that id.
 */
export const DASHBOARD_WEB_CHAT_SUBSCRIBER_PREFIX = 'novu-dashboard-web-chat';
export function buildDashboardWebChatSubscriberId(userId) {
    return `${DASHBOARD_WEB_CHAT_SUBSCRIBER_PREFIX}:${userId}`;
}
export function isDashboardWebChatSubscriberId(subscriberId) {
    if (!subscriberId) {
        return false;
    }
    return subscriberId.startsWith(`${DASHBOARD_WEB_CHAT_SUBSCRIBER_PREFIX}:`);
}
//# sourceMappingURL=dashboard-web-chat-subscriber.js.map